import { css } from "@compiled/react";

export interface UnreadIndicatorProps {
    fillColour: string;
    halfFill?: boolean;
}

const indicatorStyles = css({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
});

export const UnreadIndicator = ({
    fillColour,
    halfFill = false
}: UnreadIndicatorProps) => {
    return (
        <div css={indicatorStyles}>
            <svg
                data-testid="unread-indicator"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24px"
                height="24px"
                fill="none"
            >
                {halfFill && (
                    <>
                        <circle cx="50%" cy="50%" r="4" stroke={fillColour} />
                        <clipPath id="cut-off-left">
                            <rect x="12" y="0" width="12" height="24" />
                        </clipPath>
                    </>
                )}
                <circle
                    cx="50%"
                    cy="50%"
                    r="4"
                    fill={fillColour}
                    clipPath={halfFill ? "url(#cut-off-left)" : undefined}
                />
            </svg>
        </div>
    );
};
